(function($) {
    'use strict';

    document.addEventListener('alpine:init', () => {
        Alpine.data('MiniCart', () => ({
            initialized: false,
            count: 0,
            totals: '',
            items: '',
            actionBar: null,
            flyoutComponent: null,

            init() {
                this.requestInitialData();

                const bar = document.querySelector('.action-bar');
                if (bar) {
                    this.actionBar = bar;
                }

                this.$nextTick(() => {
                    const flyoutEl = document.querySelector('[x-data^="flyout("]');
                    if (flyoutEl && Alpine.$data) {
                        this.flyoutComponent = Alpine.$data(flyoutEl);

                        this.$watch(() => this.flyoutComponent.open, value => {
                            if (!value) {
                                this.showActionBar();
                            }
                        });
                    }
                });
            },

            events: {
                ['@mini-cart-refresh.window']: function (e) {
                    this.updateData(e.detail);
                    this.$dispatch('flyout-show', 'mini-cart');
                    this.hideActionBar();
                },

                ['@quantity-changed.window']: function (e) {
                    this.onQuantityChanged(e);
                }
            },

            onClickMiniCartButton() {
                this.$dispatch('flyout-show', 'mini-cart');
                this.hideActionBar();
            },

            hideActionBar() {
                if (!this.actionBar) return;
                if (this.actionBar.classList.contains('active')) {
                    this.actionBar.classList.add('inactive');
                }
            },

            showActionBar() {
                if (!this.actionBar) return;
                this.actionBar.classList.remove('inactive');
            },

            async onQuantityChanged(e) {
                e.detail.target.block({
                    message: null,
                    overlayCSS: { opacity: 0.6 },
                });

                const data = new FormData();
                data.append('cart_item_key', e.detail.cart_item_key);
                data.append('quantity', e.detail.quantity);

                return $.ajax({
                        url: '/?wc-ajax=cart_item_update',
                        method: 'post',
                        processData: false,
                        contentType: false,
                        xhrFields: { withCredentials: true },
                        data: data,
                    })
                    .done(r => { if (r.success) this.updateData(r.data); })
                    .always(() => e.detail.target.unblock());
            },

            updateData(data) {
                this.count = data.count;
                this.totals = data.totals;
                this.items = data.items;
            },

            requestInitialData() {
                fetch('/?wc-ajax=cart')
                    .then(r => r.json())
                    .then(r => {
                        this.initialized = true;
                        if (r.success) this.updateData(r.data);
                    });
            },
        }));
    });

    return;

    class Cart {
        constructor() {
            $(document.body)
                .on(
                    'click',
                    '.mini-cart__cart-icon',
                    this.onMouseOver,
                );
            $(document.body).on('click', '.close-mini-cart', this.onMouseOut);

            $(document).on('cart/show', this.show);
            $(document).on('cart/hide', this.hide);

            $(document.body)
                .on('click', '.mini-cart__dropdown', this.onClickCartOverlay);

            document.addEventListener('DOMContentLoaded', this.init);
        }

        init = () => {
            const url = new URL(
                '?wc-ajax=get_refreshed_fragments',
                document.location.origin,
            );

            fetch(url.toString())
                .then(response => {
                    response.json()
                        .then(data => this.updateFragments(data.fragments));
                });
        };

        show = () => {
            $('.action-bar').addClass('hidden');
            $(document.body).addClass('mini-cart--visible');

            $('body').attr('data-pos', $(window).scrollTop());
            $('html').addClass('flyout--open');
        };

        hide = () => {
            $(window).scrollTop($('body').attr('data-pos'));

            const $elements = $(
                '.cart_list_wrp, .woocommerce-mini-cart__total, .woocommerce-mini-cart__buttons');

            $elements.addClass('closed');

            setTimeout(function() {
                $(document.body).removeClass('mini-cart--visible');
                $elements.removeClass('closed');
                $('.action-bar').removeClass('hidden');
                $('html').removeClass('flyout--open');
            }, 500);
        };

        updateFragments = (fragments) => {
            $.each(fragments, (key, value) => {
                $(key).replaceWith(value);
            });
        };

        onClickCartOverlay = (e) => {
            if (e.target.className !== 'mini-cart__dropdown') {
                return;
            }

            this.hide();
        };

        onMouseOver = () => {
            this.show();
        };

        onMouseOut = () => {
            this.hide();
        };
    }

    new Cart();
}(jQuery));
